import React from 'react';
import { Row, Col, Collapse } from 'antd';
import { ReactComponent as Bin } from 'assets/icons/bin.svg';
import { FormField } from 'components';
import { fieldsRecAndRepr} from './field';
import { useSelector } from 'react-redux';
import { contentRecAndRepr, contentEmpAndPerf } from './content';
import { Upload } from 'components';
import { isNil } from 'lodash';

const { Panel } = Collapse;

const Companies = ({ update, removeCompany, index, key, companies, options, disabled }) => {
  const docsCompanies = useSelector(state => state.forms.documents.companies);

  const handleChange = ({ key, event, type }) => {
    let newValue;
    if (type === 'text' || type === 'textarea' || type === 'radio') {
      newValue = event.target.value;
    } else if (type === 'number' || type === 'select' ) {
      newValue = event;
    } else if(type === 'upload') {
      //event.response ---> in case of upload documents
      //event.response ---> in case of delete documents
      newValue = event.response || event.file;
    }

    update({ key, value: newValue, index, type });
  };

  return (
    <div className='companiesCollapse'>
      <Collapse>
        <Panel header={
          <>
          <Row>
              <span>{docsCompanies[index].cmpNameAff ? index + 1 + '. ' +  `Στοιχεία Συμπλήρωσης Συνεργαζόμενης - Συνδεδεμένης Επιχείρησης: ` + docsCompanies[index].cmpNameAff : 'Στοιχεία Συμπλήρωσης Συνεργαζόμενης - Συνδεδεμένης Επιχείρησης'}</span>
              {!disabled && <div className='removeBtnCompany'>
                  <Bin onClick={() => removeCompany(index)} />
              </div>
              }
            </Row>
          </>
        }>

        {fieldsRecAndRepr.map((field, i) => {
          return (
            <Col key={i} span={!disabled ? field.span: 24} className="pt-1 pb-1 mb-3">
              <FormField
                {...field}
                value={companies[index] && companies[index][field.name]}
                disabled={disabled}
                onChange={event =>{
                  handleChange({
                    type: field.type,
                    key: field.name,
                    event,
                  })}
                }
              />
            </Col>          
          );
        })}
     
        {contentRecAndRepr(docsCompanies[index]).map((item, i) => {
            return (
              <Upload 
                item={item} 
                key={i} 
                ind={index}
                group={'documents'} 
                subgroup={'companies'}
                subFileCode={item.fileCode}
                updateDocs={(response) =>
                    {  
                    handleChange({
                      type: 'upload',
                      key: contentRecAndRepr(docsCompanies[index])[i].fileCode,
                      event: response,
                    })
                  }
                }
              />
            );
          })}
      </Panel>
      </Collapse>
    </div>
  );
};

export default Companies;
